import { CssBaseline, IconButton, Toolbar, Typography } from "@mui/material";
import { useAtomValue } from "jotai/index";
import logo from "../../../src/assets/logo.svg";
import { viewTitle } from "../../state/view";
import AppBarContainer from "./navigation/top/AppBarContainer";
import ViewSnackbar from "./viewComponents/ViewSnackbar";

/**
 * The simplified version of the main application layout component, which renders only the top bar.
 *
 * @returns the simplified application main layout component
 */
const SimplifiedAppLayout = () => {
	const title = useAtomValue(viewTitle);

	return (
		<>
			<CssBaseline />
			<AppBarContainer>
				<Toolbar className="app-bar">
					<IconButton edge="start" color="inherit" disabled>
						<img width={24} src={logo} alt="green-router-logo" />
					</IconButton>
					<Typography className="app-bar-title" variant="h6" flexGrow={1}>
						{title}
					</Typography>
				</Toolbar>
			</AppBarContainer>
			<ViewSnackbar />
		</>
	);
};

export default SimplifiedAppLayout;
